module.exports = __webpack_public_path__ + "img/telemedicine.a9163048.jpg";